/**
 * Doc-type classification shared by every Product Dev Files surface.
 *
 * `product_dev_files` is the single storage table behind the whole record, so
 * images that belong to a CARD (colourway photos and swatches, trim images,
 * sample-round galleries) live there next to genuine documents (tech pack,
 * spec sheet, lab dip). Only the documents belong in a Files list.
 *
 * BLU-629 M1 — why this is a correctness rule, not tidiness: `sample_round_photo`
 * and `variant_swatch` were missing from the buyer's copy of this list, so they
 * surfaced in Files as untitled rows — and deleting one THERE cascaded the
 * owning `product_dev_sample_photos` / variant row away via the `file_id` FK,
 * silently destroying the photo on the sample round. The partner detail page
 * inherits the same hazard now that a supplier can delete their own uploads.
 *
 * Any new doc_type written by a card that renders its own images belongs here.
 */
export const NON_DOCUMENT_DOC_TYPES: readonly string[] = [
  'variant_photo',
  'variant_swatch',
  'trim_image',
  'sample_round_photo',
];

/** True when the file is a card-owned image rather than a listable document. */
export const isNonDocumentDocType = (docType: string | null | undefined): boolean =>
  NON_DOCUMENT_DOC_TYPES.includes(docType ?? '');
